import React from 'react';
import Button from '@material-ui/core/Button';
import { optOutPatientAction } from '../../services/customer.service';

const OptOutPatient = ({ data }) => {
    const { patient_id, mobile_number, email_address, status, program_id } = data;

    const onClick = async () => {
        if (window.confirm('Do you want to opt out this patient?')) {
            await optOutPatientAction({
                program_id, 
                payload: {
                    msisdn: mobile_number || "",
                    emailto: email_address.replace(/ /g, '+'),
                    text: 'STOP',
                }
            })
            .then((res) => {
                alert(res.message);
                window.location.reload();
            })
            .catch((err) => alert(err.message));
        }
    };

    return (
        status !== 'cancelled' && 
        <Button variant="contained" onClick={onClick} style={{ marginRight: 8 }}>Opt Out</Button>
    )
}

export default OptOutPatient;